"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TrophyFilled = function TrophyFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.5 5h-1.555Q20 4.274 20 3.5a.5.5 0 00-.5-.5h-15a.5.5 0 00-.5.5q0 .774.055 1.5H2.5a.5.5 0 00-.5.5c0 2.144.861 6.1 4.03 6.464A14.87 14.87 0 0010 16.757v1.383l-2.658.885A.5.5 0 007 19.5v1a.5.5 0 00.5.5h9a.5.5 0 00.5-.5v-1a.5.5 0 00-.342-.475L14 18.14v-1.383a14.87 14.87 0 003.97-4.793C21.139 11.6 22 7.644 22 5.5a.5.5 0 00-.5-.5zM3.025 6h1.141a17.388 17.388 0 001.308 4.809C3.54 10.048 3.117 7.172 3.025 6zm10.411 3.761l.837 2.739L12 10.832 9.727 12.5l.837-2.739-2.033-1.788h2.587L12 5.5l.882 2.473h2.587zm5.09 1.048A17.388 17.388 0 0019.834 6h1.141c-.092 1.172-.515 4.048-2.449 4.809z",
    fill: "currentColor"
  })));
};

var _default = TrophyFilled;
exports["default"] = _default;